import {Component, HostListener, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {UploadCollection} from "../../objects/uploadCollection";
import {UPLOAD_ITEM_STATUS} from "../../objects/uploadStatuses";
import {Subject} from "rxjs";
import {HttpEventType, HttpResponse} from "@angular/common/http";
import {ApiService} from "../../api.service";
import {SharedDataService} from "../../services/shared-data.service";
import * as he from 'he';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'app-quick-uploader',
  templateUrl: './quick-uploader.component.html',
  styleUrls: ['./quick-uploader.component.scss']
})
export class QuickUploaderComponent implements OnInit {

  @HostListener('dragover', ['$event']) public onDragOver($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }
  @HostListener('dragleave', ['$event']) public onDragLeave($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }
  // Drop listener
  @HostListener('drop', ['$event']) public async ondrop($event) {
    $event.preventDefault();
    $event.stopPropagation();
    await this.getAllFileEntries($event.dataTransfer)
  }

  private async getAllFileEntries({ items, files }) {
    console.log(items.length, files.length)
    if (!items.length || items.length !== files.length) {
      return null;
    }

    const onlyFiles = await this.getOnlyFiles(files);
    if (onlyFiles.length !== files.length) {
      this.sharedDataService.pushNotification({ text: 'Your browser does not support drag&drop of directories', type: 'warning' })
    }

    onlyFiles.forEach(file => this.handleAddNewFile(file))
    return
  }
  /* Filter dataTransfer.files to remove dragged folders,
     because we can't read that folder we need to skip that folder
  */
  private async getOnlyFiles(items) {
    const files = [];
    for (let i = 0; i < items.length; i++) {
      try {
        if (await this.checkIfFile(items[i])) {
          files.push(items[i]);
        }
      } catch (error) {
        continue;
      }
    }
    return files;
  };
  /* There is only one reliable method to check if it is file
      folder cannot be readed by FileReader and will throw an error.
      Relying on size 4096 is not strong solution cause also size can be 8192(on Linux distros)
      and also it can be just a file with size 4096 bytes which is fully valid
  */
  private checkIfFile(file) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => resolve(true);
      reader.onerror = () => resolve(false);
      reader.readAsText(file.slice(0, 1));
    });
  }

  // To get native File from FileEntry
  private getFile(fileEntry) {
    return new Promise((resolve, reject) => fileEntry.file(resolve, reject));
  }

  private uploadFile: object;
  @Input() public picture_src: string;
  @Input() public aspect_ratio: number;
  @Input() public is_circle: boolean = false;
  @Input() public self_avatar: boolean = false;
  @Output() new_picture_src = new EventEmitter<string>();
  @Output() new_picture_src_ava = new EventEmitter<string>();
  @Output() new_picture_src_icon = new EventEmitter<string>();
  @Output() new_picture_src_preview = new EventEmitter<string>();
  @Output() new_aspect_ratio = new EventEmitter<number>();
  constructor(
    private apiService: ApiService,
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
  }

  public handleFileInput(event): void {
    const file: File = event.target.files[0];
    this.handleAddNewFile(file);
  }

  private handleAddNewFile(file: File): void {
    console.log('this.aspect_ratio',this.aspect_ratio);
    this.uploadFile = {
      uuid: uuid().toUpperCase(),
      force_aspect_ratio: this.aspect_ratio,
      originalFile: file,
      name: file.name,
      size: file.size, start: 0, end: 0, totalUploaded: 0,
      state: UPLOAD_ITEM_STATUS.UPLOAD_UPLOADING
    };
    this.readFileAndUpload(this.uploadFile, 0)
  }

  private uploadFinished() {
    console.log(this.uploadFile);
    this.picture_src = this.uploadFile['result']['preview'];
    //this.aspect_ratio = this.uploadFile['result']['aspect_ratio'];
    this.new_picture_src.emit(this.picture_src)
    this.new_picture_src_ava.emit(this.uploadFile['result']['ava'])
    this.new_picture_src_icon.emit(this.uploadFile['result']['icon'])
    this.new_picture_src_preview.emit(this.uploadFile['result']['preview'])
    this.new_aspect_ratio.emit(this.uploadFile['result']['aspect_ratio'])
  }
  private deletePicture() {
    this.picture_src = '';
    //this.aspect_ratio = 1;
    this.new_picture_src.emit(this.picture_src)
    this.new_picture_src_ava.emit('')
    this.new_picture_src_icon.emit('')
    this.new_picture_src_preview.emit('')
    this.new_aspect_ratio.emit(this.aspect_ratio)
  }

  private readFileAndUpload(file, uploadedBytes) {
    const fileContent = file.originalFile;
    if (uploadedBytes) {
      file.totalUploaded += uploadedBytes;
    }
    if (file.totalUploaded < file.size || (file.size === 0 && uploadedBytes === file.size)) {
      //file.chunkSize = Math.min(Math.min(file.size - file.totalUploaded, file.chunkSize || UPLOAD_ITEM_STATUS.DEFAULT_CHUNK_SIZE), UPLOAD_ITEM_STATUS.MAX_CHUNK_SIZE);
      //const blob = fileContent.slice(file.totalUploaded, file.totalUploaded + file.chunkSize);
      file.chunkSize = file.size
      const blob = fileContent; //1 chunk, can't be bothered

      file.start = file.end;
      file.end = file.start + file.chunkSize;

      // For abort request
      file.cancelSource = new Subject<void>();
      file.cancelObservable = file.cancelSource.asObservable();
      const fileMetaParams = {uuid: file.uuid, filename: window.encodeURIComponent(file.name), force_ratio: file.force_aspect_ratio}
      file.xhr = this.apiService.uploadChunks(fileMetaParams, blob, file.start, file.end - 1, file.size, file.cancelObservable)
        .subscribe(event => {
          if (event instanceof HttpResponse) {
            if (event.status === 200) {
              file.state = UPLOAD_ITEM_STATUS.UPLOAD_FINISHED;
              file.result = event.body;
              this.uploadFinished();
              return
              //this.readFileAndUpload(file, file.end - file.start);
            }
          }
        }, err => {
          if (file.state === UPLOAD_ITEM_STATUS.UPLOAD_CANCELED) {
            return
          }

          if (err) {
            const { exception: { status, error } } = err;

            if (!status) { // no connection or abort
              this.sharedDataService.pushNotification({
                text: 'Sorry, Internet connection error occurred. Please check your Internet connection.',
                type: 'error'
              })
              file.errorMsg = 'Please check your connectivity';
              file.state = UPLOAD_ITEM_STATUS.UPLOAD_PAUSED_ON_ERROR;
              //this.setResumeWorker(); todo
              this.revertFileReadPosition(file);
              file.chunkSize = UPLOAD_ITEM_STATUS.DEFAULT_CHUNK_SIZE;
              return
            }

            file.state = UPLOAD_ITEM_STATUS.UPLOAD_ERROR;

            if (status === 400) {
              this.sharedDataService.pushNotification({ text: error.message, type: 'error' })
              file.errorMsg = error.message;
            }
            if (status === 403) {
              this.sharedDataService.pushNotification({ text: 'Sorry, you have exceeded storage quota', type: 'error' })
              file.errorMsg = 'Sorry, you have exceeded storage quota';
              file.state = UPLOAD_ITEM_STATUS.UPLOAD_PAUSED_ON_ERROR;
            }
            if (status === 413) {
              this.sharedDataService.pushNotification({ text: 'File is too big', type: 'error' })
              file.errorMsg = 'File is too big';
            }
            if (status >= 500) {
              this.sharedDataService.pushNotification({ text: 'Something went wrong, please try again later', type: 'error' })
              file.errorMsg = 'Something went wrong, please try again later';
            }
          }

          this.revertFileReadPosition(file);
        })

    } else if (file.totalUploaded === file.size) {
      file.state = UPLOAD_ITEM_STATUS.UPLOAD_FINISHED
    }
  }

  // If chunk upload failed, we need to send it again
  private revertFileReadPosition(file) {
    const buff = file.end;
    file.end = file.start;
    file.start = buff - file.chunkSize;
  };

}
